import { type BaseUser, getUserProgramState } from 'Users';
import { type Playlist, type PlaylistIguanaObject } from './Playlists.types';

export function deriveActivePlaylist<PlaylistType extends Playlist | PlaylistIguanaObject>(
    playlists: PlaylistType[],
    user: BaseUser,
) {
    const prefUps = getUserProgramState(user);
    // ensure we always handle the single-playlist scenario consistently
    const activePlaylist =
        playlists?.length === 1
            ? playlists[0]
            : (playlists || []).find(playlist => playlist.localePackId === prefUps?.activePlaylistLocalePackId);

    return activePlaylist ?? null;
}
